import Table from "components/Table";
import { useMemo, useEffect, useState } from "react";
import { useMap } from "context/mapContext";
import { useLoading, handleLoading } from "context/LoadingContext";
import getEsriDataFromLayer from "context/contextFunctions/getEsriDataFromLayer";
import UnitsReportFilter from "./UnitsReportFilter";

export default function UnitsReport() {
  const [map] = useMap();
  const [, dispatchLoading] = useLoading();
  const { view, unitsTable, installedUnits } = map;

  const [wattageCounters, setWattageCounters] = useState(null);

  const headers = useMemo(
    () => [
      {
        accessorKey: "Unit_Prod_ID",
        header: "Unit ID",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Pallet_ID",
        header: "Pallet ID",
        enableColumnFilter: false,
      },
      // {
      //   accessorKey: "Pole_ID",
      //   header: "Pole ID",
      //   enableColumnFilter: false,
      // },
      {
        accessorKey: "CategoryName",
        header: "Category",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Governorate",
        header: "Governorate",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Municipality",
        header: "Municipality",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Location",
        header: "Location",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Stage",
        header: "Stage",
        enableColumnFilter: false,
      },
      {
        accessorKey: "Is_Installed",
        header: "Status",
        enableColumnFilter: false,
        cell: (param) => param.cell.row.original.Is_InstalledName,
      },
      {
        accessorKey: "Action_to_be_taken",
        header: "Action",
        enableColumnFilter: false,
      },
      {
        accessorKey: "X",
        header: "X",
        enableColumnFilter: false,
        cell: (param) => param.cell.row.original.X,
      },
      {
        accessorKey: "Y",
        header: "Y",
        enableColumnFilter: false,
        cell: (param) => param.cell.row.original.Y,
      },
      {
        accessorKey: "Installation_Date",
        header: "Installation Date",
        enableColumnFilter: false,
        cell: (param) => param.cell.row.original.Installation_Date_ISO,
      },
    ],
    []
  );

  const exportHeaders = useMemo(
    () => [
      {
        label: "Unit ID",
        key: "Unit_Prod_ID",
      },
      {
        key: "Pallet_ID",
        label: "Pallet ID",
      },
      // {
      //   key: "Pole_ID",
      //   label: "Pole ID",
      // },
      {
        key: "CategoryName",
        label: "Category",
      },
      {
        key: "Governorate",
        label: "Governorate",
      },
      {
        key: "Municipality",
        label: "Municipality",
      },
      {
        key: "Location",
        label: "Location",
      },
      {
        key: "Stage",
        label: "Stage",
      },
      {
        key: "Is_InstalledName",
        label: "Status",
      },
      {
        key: "Action_to_be_taken",
        label: "Action",
      },
      {
        key: "X",
        label: "X",
      },
      {
        key: "Y",
        label: "Y",
      },
      {
        key: "Installation_Date_ISO",
        label: "Installation Date",
      },
    ],
    []
  );

  useEffect(() => {
    if (installedUnits && installedUnits.length) {
      const tempWattageCounters = installedUnits.reduce(
        (counter, wattageItem) => {
          if (wattageItem.Category === "30")
            return { ...counter, watt30: counter.watt30 + 1 };
          if (wattageItem.Category === "40")
            return { ...counter, watt40: counter.watt40 + 1 };
          if (wattageItem.Category === "70")
            return { ...counter, watt70: counter.watt70 + 1 };
          return counter;
        },
        {
          watt30: 0,
          watt40: 0,
          watt70: 0,
        }
      );

      setWattageCounters(tempWattageCounters);
    } else {
      (async () => {
        handleLoading(dispatchLoading, true);
        try {
          const token = localStorage.getItem("token");
          if (unitsTable && view && token) {
            const { res: unitsRes } = await getEsriDataFromLayer({
              featureLayer: unitsTable,
              outFields: "Category",
              restQueryParams: {
                groupByFieldsForStatistics: ["Category"],
                outStatistics: [
                  {
                    statisticType: "count",
                    onStatisticField: "OBJECTID",
                    outStatisticFieldName: "Quantity",
                  },
                ],
              },
            });

            const watt30Cat = unitsRes.find(
              (item) => item.Category === "30"
            ).Quantity;
            const watt40Cat = unitsRes.find(
              (item) => item.Category === "40"
            ).Quantity;
            const watt70Cat = unitsRes.find(
              (item) => item.Category === "70"
            ).Quantity;

            setWattageCounters({
              watt30: watt30Cat,
              watt40: watt40Cat,
              watt70: watt70Cat,
            });
          }
        } catch (error) {
          console.log(error);
        }
        handleLoading(dispatchLoading, false);
      })();
    }
  }, [installedUnits, unitsTable]);

  return (
    <div>
      {wattageCounters && (
        <div
          className="d-flex"
          style={{ justifyContent: "space-between", marginBottom: "30px" }}
        >
          <div
            className="wattage_card"
            style={{ boxShadow: "0px 0px 2px #CCB642" }}
          >
            <i
              className="fa-regular fa-lightbulb"
              style={{ color: "#CCB642" }}
            />
            <div className="d-grid">
              <span
                className="wattage_card__title"
                style={{ color: "#CCB642" }}
              >
                30 Watt:
              </span>
              <span className="wattage_card__value">
                {wattageCounters.watt30}
              </span>
            </div>
          </div>
          <div
            className="wattage_card"
            style={{ boxShadow: "0px 0px 2px #6998B4" }}
          >
            <i
              className="fa-regular fa-lightbulb"
              style={{ color: "#6998B4" }}
            />
            <div className="d-grid">
              <span
                className="wattage_card__title"
                style={{ color: "#6998B4" }}
              >
                40 Watt:
              </span>
              <span className="wattage_card__value">
                {wattageCounters.watt40}
              </span>
            </div>
          </div>
          <div
            className="wattage_card"
            style={{ boxShadow: "0px 0px 2px #A67474" }}
          >
            <i
              className="fa-regular fa-lightbulb"
              style={{ color: "#A67474" }}
            />
            <div className="d-grid">
              <span
                className="wattage_card__title"
                style={{ color: "#A67474" }}
              >
                70 Watt:
              </span>
              <span className="wattage_card__value">
                {wattageCounters.watt70}
              </span>
            </div>
          </div>
        </div>
      )}
      <UnitsReportFilter />
      <Table
        columns={headers}
        data={installedUnits}
        exportName={`Units-Report-${new Date().toISOString().split("T")[0]}`}
        exportColumns={exportHeaders}
      />
    </div>
  );
}
